<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="50%">
    <UE
      :value="content"
      id="bs"
      :key="dialogVisible"
      name="1"
      reff="myQuillEditorTitle"
      ref="myQuillEditorTitle"
    ></UE>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="addUEBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UE from "../../../question/UE.vue";
export default {
  props: {
    title: String,
    content: String,
  },
  components: { UE },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    addUEBtn() {
      this.$emit("addUEBtn", this.$refs.myQuillEditorTitle._data.content);
      this.dialogVisible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/designPage/template/components/UEDialog.vue